'use strict'

angular
  .module('surfsightApp.controllers')
  .controller('organizationDataProfileSettingsEditController', [
    '$scope',
    '$mdDialog',
    '$mdColors',
    '$filter',
    '$mdToast',
    '$localStorage',
    '$http',
    function (
      $scope,
      $mdDialog,
      $mdColors,
      $filter,
      $mdToast,
      $localStorage,
      $http
    ) {
      const $translate = $filter('translate')
      $scope.themePrimary = $mdColors.getThemeColor('primary')
      $scope.themeAccent = $mdColors.getThemeColor('accent')
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .hideDelay(5000)
        $mdToast.show(toast).then(function (response) {
          if (response == 'ok') {
          }
        })
      }

      const handleServerError = error => {
        $scope.$emit('handleServerError', error)
      }

      $scope.cancelDataProfileSettings = () => {
        $mdDialog.cancel()
      }
      $scope.saveDataProfileSettings = () => {
        $mdDialog.hide({ defaultDataProfileId: $scope.defaultDataProfileId })
      }

      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'

      const loadCurrentDefaultDataProfileId = async () => {
        await $http({
          method: 'GET',
          url:
            V2_BASEURL +
            `/organizations/${$localStorage.currentUserOrganization.id}/data-profile`
        })
          .then(function (response) {
            $scope.defaultDataProfileId =
              response.data.data.defaultDataProfileId || null
          })
          .catch(error => {
            handleServerError(error)
            $scope.showMessageToast($translate('errorOccurredPleaseTryAgain'))
          })
      }
      loadCurrentDefaultDataProfileId()
      const loadDataProfiles = async () => {
        await $http({
          method: 'GET',
          url: DEVICE_BASEURL + '/data-profiles'
        })
          .then(function (response) {
            if (response.data.status.code === 0) {
              $scope.dataProfiles = response.data.dataProfiles
            } else {
              $scope.showMessageToast($translate('errorOccurred'))
            }
          })
          .catch(error => {
            handleServerError(error)
            $scope.showMessageToast($translate('errorOccurredPleaseTryAgain'))
          })
      }
      loadDataProfiles()
    }
  ])
